import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { City, Country } from 'sham-components/shared/models/auth';
import { map, of } from 'rxjs';
import { AppEnvironment } from './core/app-environment';
@Injectable({
  providedIn: 'root',
})
export class ShamGeoApi {
  private readonly appEnv = inject(AppEnvironment);
  private readonly http = inject(HttpClient);

  getCountries(lang: 'en' | 'ar' = 'en'): Observable<Country[]> {
    return this.http.get<Country[]>(`${this.appEnv.API_BASE_URL()}/v1/geo/countries`);
  }

  getCities(countryId: string, lang: 'en' | 'ar' = 'en'): Observable<City[]> {
    return this.http.get<City[]>(
      `${this.appEnv.API_BASE_URL()}/v1/geo/cities?countryId=${countryId}`,
    );
  }

  // داخل ShamGeoService
  getCityName(
    countryId: string,
    cityId: string,
    lang: 'en' | 'ar' = 'en',
  ): Observable<string> {
    if (!cityId) return of('');

    return this.getCities(countryId, lang).pipe(
      map((cities) => cities.find((c) => c.id === cityId)?.name || cityId),
    );
  }
}
